'use strict';

import angular from 'angular';
import { Enum } from '../../enum/index';

export class InsuranceOfferEditPopupController {
  forms = {
    insuranceOfferForm: null
  };
  Enum = Enum;

  /*@ngInject*/
  constructor(mdPanelRef, $mdPanel, insuranceOffer, insuranceData, pageSettings, helper) {
    let vm = this;
    vm._mdPanelRef = mdPanelRef;
    vm.$mdPanel = $mdPanel;
    vm.insuranceOffer = insuranceData;
    vm.theme = pageSettings.theme;


    vm.save = () => {
      vm.forms.insuranceOfferForm.$setSubmitted();

      if (vm.forms.insuranceOfferForm.$valid) {
        insuranceOffer.update(vm.insuranceOffer).then(data => {
          vm.hide();
          helper.showOperationSuccessToast();
        }).catch(() => {
          helper.showOperationFailedToast();
        });
      }
    };
    vm.hide = function () {
      let panelRef = vm._mdPanelRef;
      panelRef.destroy();
    };

  }
  cancel() {
    this._mdPanelRef.hide();
  }
}

export default angular.module('ngOskCrmApp.popup.insuranceOfferEditPopupController', [])
  .controller('insuranceOfferEditPopupController', InsuranceOfferEditPopupController)
  .name;



// WEBPACK FOOTER //
// ./client/app/shared/popup/edit-insurance-offer-popup/edit-insurance-offer-popup.controller.js